import { ILocalizable } from "infrastructure/localization";
import { INotification } from "infrastructure/notification";
import { IValidationIssue } from "infrastructure/validation";

export interface ITermTranslationsUploadError {
  validationIssues?: ITermTranslationsUploadValidationIssue[];
  text?: ILocalizable | string;
}

export interface ITermTranslationsUploadValidationIssue {
  uniqueId: string;
  key: string;
  translationId: string;
  locale: string;
  industry: string;
  termTranslation: string;
  definitionTranslation: string;
  validationIssue: IValidationIssue;
}

export interface ITermTranslationsUploadState {
  uploadProcessing: boolean;
  uploadCompleted: boolean;
  error?: ITermTranslationsUploadError;
  notifications: INotification[];
  progress: number;
}

export const getInitialTermTranslationsUploadState = (): ITermTranslationsUploadState => ({
  uploadProcessing: false,
  uploadCompleted: false,
  notifications: [],
  progress: 0
});
